import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getter'
import state from './state'
import mutations from './mutations'
import actions from './actions'
Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js